import type { FeatureTriggerTuning } from "@slot/game-shell";
import type { SpinePanelFadeTuning } from "@slot/presentation";

// Per-game FEATURE-TRIGGER ("feature enter") panel tuning VALUES — the ONLY file to edit to retune
// it. The shell's part (FeatureTriggerTuning: the arm delay, the sounds, the music) is passed whole
// into FeatureTriggerPresenter (wired in createPresentation). The game's view (FeatureTriggerView) is
// SPINE-DRIVEN (the freespins Spine owns the enter/idle/exit motion) and reads its fades from `anim`
// (SpinePanelFadeTuning): the dim's fade in / out and the hint's.

export const FEATURE_TRIGGER_TUNING: FeatureTriggerTuning & { anim: SpinePanelFadeTuning } = {
  armDelayMs: 800,
  openSoundId: "feature_trigger_panel_open",
  closeSoundId: "feature_trigger_panel_close",
  music: {
    idleId: "music_feature_idle",
    idleFadeInDelayMs: 400,
    idleFadeMs: 1500,
    loopId: "music_feature_free_spins",
    loopFadeMs: 1500,
  },
  anim: {
    enterDurationSeconds: 0.35,
    exitDurationSeconds: 0.25,
    continueFadeInSeconds: 0.4,
    continueFadeOutSeconds: 0.2,
  },
};
